// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whiteSpaceKPITable .ck.ck-editor {
  width: 185px;
}
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #F6F8FC !important;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


html,
body {
   margin:0;
   padding:0;
   height:100%;
}
#root {
   min-height:96%;
   position:relative;
}
#body {
   padding-bottom:16px;   /* Height of the footer */
}
.whiteSpaceKPITable {
  width: 100%;
  margin-top: 8px;
}
.whiteSpaceKPITable tbody td {
  padding: 8px 4px;
  border-bottom:1px solid #9FD0FA ;
  /* color: #0b0c0c; */
  font-weight: 600;
  font-size: 13px;
}
.whiteSpaceKPITable tbody tr:last-child td {
  border-bottom:none ;
}
.whiteSpaceKPITable thead td {
  padding: 8px 4px;
  color: #104B72;
  font-weight: 600;
  font-size: 14px;
  background: #E0E8FA;
  white-space: nowrap;
  border-left:1px solid #104B72;
}
.whiteSpaceKPITable thead td:first-child {
  border-left: none;
}
.whiteSpaceKPITable thead  {
  border-radius: 5px;
}
.whiteSpaceKPITable thead td:first-child {
  border-radius: 5px 0 0 5px;
}
.whiteSpaceKPITable thead td:last-child {
  border-radius: 0 5px 5px 0;
}
#footer {
   position:absolute;
   bottom:0;
   width:100%;
   height:60px;   /* Height of the footer */
   text-align: center;
   padding: 20px 0;
}
#footerData{
  padding: 8px 0;
  font-size: 13px;
  color: #4a4848;
}

::-webkit-scrollbar
{
  width: 10px;  /* for vertical scrollbars */
  height: 8px; /* for horizontal scrollbars */
}

::-webkit-scrollbar-track
{
  background: rgba(0, 0, 0, 0.2);
}

::-webkit-scrollbar-thumb
{
  background: rgba(0, 0, 0, 0.4);
  width: min-content;
  border-radius: 10px;
}
.clearfix::after {
  content: "";
  clear: both;
  display: table;
}
.datePicker{
  height: 32px;
  padding: 4px 4px 4px 8px;
  border: 1px solid #ececec;
  border-radius: 5px;
  width: 100%;
}
.datePickerError{
  height: 32px;
  padding: 4px 4px 4px 8px;
  border: 1px solid red;
  border-radius: 5px;
  width: 100%;
}
.datePickerDetailedView{
 height: 24px;
  padding: 2px;
  border: 1px solid #cccccc;
  border-radius: 2px;
  width: 100%; 
  font-size: 12px;
}
.datePickerDetailedView input{
  font-size: 12px !important;
}
.datePickerFilter{
  height: 24px;
  padding: 4px 4px 4px 8px;
  border: 1px solid #cccccc;
  border-radius: 2px;
  width: 100%;
}
.customCheckBox.MuiButtonBase-root {
  width: 20px;
  height: 20px;
}
.customCheckBox .MuiSvgIcon-root{
  width: 16px;
  height: 16px;
}
.sortItem{
  margin: 16px 0;
  position: relative;
}
.graphTableToggle .MuiToggleButton-root {
  height: 26px !important;
  color: #000;
}
.graphTableToggle .MuiToggleButton-root.Mui-selected {
  background-color: #0f8ec7 !important;
  color: #fff !important;
}
.graphTableToggle .MuiToggleButtonGroup-grouped {
  padding: 0px 4px 0px 4px !important;
}
.financialToggle .MuiToggleButton-root {
  height: 32px !important;
  color: #000;
}
.financialToggle .MuiToggleButton-root.Mui-selected {
  background-color: #0f8ec7 !important;
  color: #fff !important;
}
.financialToggle .MuiToggleButtonGroup-grouped {
  padding: 4px 16px !important;
}

.gridRadioFilter .MuiTypography-body1 {
  font-size: 13px !important;
}
.gridRadioFilter .MuiButtonBase-root {
  padding: 0 10px !important;
}

.allocationPopupRadio .MuiTypography-body1 {
  font-size: 12px !important;
  font-weight: 600;
}
.allocationPopupRadio .MuiButtonBase-root {
  padding: 0 6px !important;
}
.allocationPopupRadio .MuiSvgIcon-root{
  width: 16px;
  height: 16px;
  font-size: 16px;
  color: #0070D2;
}

.financialRadio .MuiTypography-body1 {
  font-size: 14px !important;
  font-weight: 600;
}
.financialRadio .MuiButtonBase-root {
  padding: 0 6px !important;
}
.financialRadio .MuiSvgIcon-root{
  width: 16px;
  height: 16px;
  font-size: 16px;
  color: #0070D2;
}

/*Resource Table*/
.resourceTable{
  width: 100%;
  padding: 12px 24px;
}
.resourceTable td{
  text-align: center;
}
.resourceTable thead td{
  text-align: center;
  background: #4B5558;
  color: #ffffff;
  padding: 6px;
  font-size: 14px;
  font-weight: 600;
  border-right: 1px solid #fff;
}
.resourceTable tbody td{
  color: #343434;
  padding: 6px;
  font-size: 13px;
  border-bottom: 1px solid #e3e3e3;
  border-right:1px solid #e3e3e3 ;
}
.resourceTable tbody td:first-child{
  border-left:1px solid #e3e3e3 ;
}
.resourceTable thead td:last-child{
  width: 100px;
}

/*Resource Table*/

.resourceDialog{
  padding: 0;
  /* max-width: 1200px !important; */
  /* position:absolute !important;
  left:20% !important */
}
.resourceDialog .MuiPaper-root{
  max-width: 1200px !important;
  overflow: hidden;
}
.worksheetTables{
  border-spacing: 0px;
  border-collapse: "none";
  text-indent: "initial";
}.filterMultiSelect .MuiFormControl-root{
  height:32px;
}
.filterMultiSelect .MuiInputBase-root,.filterMultiSelect .MuiSelect-outlined.MuiSelect-outlined, .filterMultiSelect .Mui-focused{
  height:32px;
  font-size: 13px;
  padding-top: 18px;
  background: none !important;
}
.filterMultiSelect .MuiOutlinedInput-notchedOutline{
  border: none !important;
}
.loadingPage {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 9999;
  position: fixed;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
}
.loadingPageLabel {
  color: #fff;
  font-size: 13px;
  font-weight: 500;
}
.react-datepicker-popper{
  z-index: 999 !important;
}

.footorLogo{
  margin-left: 8px;
  margin-top: 2px;
}
.footerDataInnerClosed{
  display: flex;
    align-items: center;
    justify-content: center;

}
.analyticsTable {
  border-collapse: separate;
  border-spacing:0 10px ;
}

.analyticsTable thead th{
  white-space: nowrap;
  text-align: left;
  padding: 8px;
}

.analyticsTable tbody td{
  white-space: nowrap;
  text-align: left;
  padding: 8px;
}
.analyticsTable thead {
  background: #4B5558;
  color: #fff;
}
.analyticsTable tbody tr{
  text-align: center;
  box-shadow: 0px 3px 6px #00000029;
  height: 50px;
  background: #fff;
  border-radius: 4px;
}
.analyticsTableMain tbody td {
  max-width: 250px;
}
.tableRowsDdl .MuiSelect-select.MuiSelect-select {
  padding-right: 12px;
  font-size: 14px;
  border: none;
  padding-left: 4px;
}
.tableRowsDdl .MuiSvgIcon-root {
  width: 18px;
  height: 24px;
  font-size: 16px;
}
.tableRowsDdl {
  margin: 0 4px !important;
  float: left;
}
.antSelectError .ant-select-selector, .errorEditor .ck.ck-editor {
  border: 1px solid red !important;
}
.ant-picker-time-panel{
  display: none !important;
}
.react-datepicker__day--outside-month {
  color: #ccc !important;
  pointer-events: none;
}
div[aria-hidden="true"].tippy-popper {
  display: none !important;
}
.generalSettingsTable{
  width: 100%;  
  word-break: break-word;
}
.generalSettingsTable thead td{
  white-space: nowrap;
  text-align: left;
  padding: 8px;
}
.generalSettingsTable thead{
  background: #4B5558;
  color: #fff;
  font-weight: 600;
}
.generalSettingsTable tbody tr {
  text-align: left;
  position: relative;
}
.generalSettingsTable tbody td {
  padding: 4px 8px;
}
.generalSettingsTable tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}
.settinsTableEdit {
  visibility: hidden;
  position: absolute;
  left: 2px;
  top: 6px;
}
.generalSettingsTable tbody tr:hover .settinsTableEdit {
  visibility: visible;
}
.generalSettingsTable tbody tr td:first-child, .generalSettingsTable thead tr td:first-child {
  padding-left: 16px;
}


.settingsTable{
  width: 100%;
  table-layout: fixed;
  word-break: break-word;
}
.settingsTable thead td{
  white-space: nowrap;
  text-align: center;
  padding: 4px 8px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
.settingsTable thead{
  background: #4B5558;
  color: #fff;
}
.settingsTable tbody tr {
  text-align: left;
}
.settingsTable tbody td {
  padding: 4px 8px;
  color: #343434;
  border-bottom:1px solid #ededed ;
}
.settingsTable tbody {
  background: #fff;
  font-size: 13px;
}
.picklistTable{
  width: 100%;
  table-layout: fixed;
  word-break: break-word;
}
.settingsTable tbody tr:last-child td {
  border-bottom:none !important;
}

.picklistTable thead td{
  white-space: nowrap;
  padding: 4px 8px;
  text-align: left;
  background: #fff;
  color: #343434;
  font-weight: 600;
  font-size: 13px;
}
.picklistTable tbody td {
  padding: 4px 8px;
  color: #343434;
  font-size: 13px;
  border: none;
}
.allocationLandingTable{
  width: 100%;
  table-layout: fixed;
  word-break: break-word;
}
.allocationLandingTable thead td{
  padding: 6px 8px;
}
.allocationLandingTable tbody td{
  font-weight: 600;
  font-size: 13px;
}
.allocationLandingTable tbody tr{
  height: auto !important;
}
.requestsTable{
  width: 120%;
  /* table-layout: fixed; */
  word-break: break-word;
}
.requestsTable thead td{
  white-space: nowrap;
  text-align: left;
  padding: 8px;
}
.requestsTable tbody td{
  font-size: 13px;
}
.requestsTable tbody tr{
  height: auto !important;
  white-space: nowrap; 
}
.requestsTable tbody tr td:nth-child(2) {
  font-weight: 600;
  cursor: pointer;
  color: #09659c;
}

.requestsTable tbody tr.released-row td:nth-child(2) {
  font-weight: 600;
  cursor: default;
  color: #999;
}
.requestsTable tbody tr td:last-child{
  font-weight: 600;
}

.reportsTable{
  width: 100%;
  /* table-layout: fixed; */
  word-break: break-word;
}
.reportsTable thead td{
  white-space: nowrap;
  text-align: left;
  padding: 8px;
}
.reportsTable tbody td{
  font-size: 13px;
}
.reportsTable tbody tr{
  height: auto !important;
  white-space: nowrap; 
}
.reportsTable {
  border-collapse: separate;
  border-spacing:0 10px ;
}

.reportsTable thead th{
  white-space: nowrap;
  text-align: left;
  padding: 8px;
}

.reportsTable tbody td{
  text-align: left;
  padding: 8px;
}
.reportsTable thead {
  background: #4B5558;
  color: #fff;
}
.reportsTable tbody tr.reportsFirstTableRow{
  text-align: center;
  box-shadow: 0px 3px 6px #00000029;
  min-height: 50px;
  background: #fff;
  border-radius: 4px;
  white-space: nowrap; 
}
.notificationTable {
  border-collapse: separate;
  border-spacing:0 10px ;
}

.notificationTable thead th{
  white-space: nowrap;
  text-align: left;
  padding: 8px;
}

.notificationTable tbody td{
  text-align: left;
  padding: 8px;
}
.notificationTable thead {
  background: #4B5558;
  color: #fff;
}
.notificationTable tbody tr{
  text-align: center;
  box-shadow: 0px 3px 6px #00000029;
  min-height: 50px;
  background: #fff;
  border-radius: 4px;
  white-space: nowrap; 
}
.allocationProjectsTable{
  width: 100%;
}
.allocationProjectsTable thead td{
  white-space: nowrap;
  text-align: center;
  padding: 4px 8px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
.allocationProjectsTable thead{
  background: #4B5558;
  color: #fff;
}

.allocationProjectsTable tbody tr{
  box-shadow: 0px 3px 6px #00000029;
  background: #fff;
  border-radius: 4px;
  position: relative;
}
.allocationProjectsTable tbody td{
  padding: 8px;
}
.spacerRow{
  background: transparent !important;
  box-shadow: none !important;
}
.allocationTableEdit {
  position: absolute;
  left: 4px;
}
.allocationProjectsTable tbody tr:hover .allocationTableEdit {
  visibility: visible;
}
.allocationPopup .MuiDialog-paperWidthSm {
  max-width: unset !important;
}

.ant-picker-calendar-date-value{
  background-color: #031d40;  
  width: 100%;  
  height: 38%;  
  text-align: center;  
  color: #ffffff;  
  font-size: 13px;  
  font-weight: 600;  
  border-radius:  12px 12px 0 0 !important;  
  border: none !important ;  
  }    
  
  .ant-picker-calendar-date-content{  
  position: static;  
  width: auto;  
  height: 45px !important;  
  overflow-y: auto;  
  color: rgba(0, 0, 0, 0.88);  
  line-height: 1.5714285714285714;  
  text-align: start;  
  }
  
  :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date {  
  display: flex;
  flex-direction: column;  
  align-items: center;  
  width: 40%;  
  height: 46px;  
  margin-bottom: 5px !important;  
  padding: 0px !important;  
  border: none;  
  border-radius: 6px !important;  
  align-items: center;  
  }
  
  :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th{  
  height: auto;  
  padding-inline-end: 12px;  
  padding-bottom: 4px;  
  line-height: 18px;  
  font-weight: 600;  
  font-size: 18px;  
  color: #4B5558;  
  padding-left: 0px !important;  
  padding-right: 86px !important;  
  }
  
  .ant-picker-date-panel .ant-picker-cell:not(.ant-picker-cell-in-view) .ant-picker-cell-inner {  
    display: none;  
  }
  :where(.css-dev-only-do-not-override-1i9hnpv).ant-input {
    padding:  2px !important;
  }
  :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-dropdown .ant-picker-cell-disabled::before {
    background: #ffffff !important;
  }
  .ant-picker-date-panel .ant-picker-cell:not(.ant-picker-cell-in-view) {  
    pointer-events: none;  
  }
  :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 40%;
    height: 46px;
    margin: 6px;
    padding: 0px !important;
    border: none !important;
    border-radius: 6px !important;
    align-items: center;
}
:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date-value {
  line-height: 18px;
  transition: color 0.3s;
}
:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {
  height: 5px !important;
  padding-inline-end:0px !important;
  padding-bottom: 0px !important;
  line-height: 5px !important;
  font-weight: 600;
  font-size: 14px;
  color: #4B5558;
  padding-right: 96px !important;
}
:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar .ant-picker-panel .ant-picker-body {
  padding: 2px 0 !important;
}
 :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date-content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #707070;
  border-radius: 0 0 12px 12px;
  background: #fff !important;
  font-size: 13px !important;
  overflow: hidden !important;
} 
:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar .ant-picker-cell {
  cursor: default !important;
}
:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date-today .ant-picker-calendar-date-value{
  color: #fff !important;
}
:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-cell-selected .ant-picker-calendar-date .ant-picker-calendar-date-value{
  color: #fff !important;
}
.ant-picker-calendar-date-content{
  font-size: 13px !important;
}
.makeStyles-inputBox-258:hover,
.makeStyles-inputBox-258:focus {
  border: 1px solid #ccc !important; /* Change border color on hover or click */
}
.ganttFirstTable{
  width: 100%;
  box-shadow: 0px 1px 6px #00000029;
  font-size: 12px;
}

.ganttFirstTable thead td{
  height: 30px;
}
.ganttFirstTable tbody td{
  padding: 0 4px;
}
.ganttSecondTable{
  display: block;
  overflow-x: auto;
  margin-left: 8px;
  box-shadow: 0px 1px 6px #00000029;
}
.ganttSecondTable tbody td{
  height: 30px;
  padding: 4px;
}
.ganttSecondTableNamed{
  display: block;
  overflow-x: auto;
  margin-left: 8px;
  box-shadow: 0px 1px 6px #00000029;
}
.ganttSecondTableNamed tbody td{
  padding: 4px;
}
.ganttFirstTableNamed{
  display: block;
  overflow-x: auto;
}
.ganttFirstTableNamed tbody td{
  padding: 4px 8px;
  font-size: 13px;
  height: 100px;
  font-weight: 600;
  white-space: nowrap;
  border-bottom:1px solid #e8e8e8 ;
}
.ganttFirstTableNamed thead td {
  white-space: nowrap;
  height: 30px;
  padding: 4px 12px;
  background: #4B5558;
  color: #ffffff;
  min-width: 60px;
}
.ganttFirstTableNamed thead td:nth-child(1) {
  min-width: 20px;
}

.ganttFirstTableNamedSecond{
  display: block;
  overflow-x: hidden;
}
.ganttFirstTableNamedSecond tbody td{
  padding: 4px 8px;
  font-size: 13px;
  height: 100px;
  font-weight: 600;
  white-space: nowrap;
  border-bottom:1px solid #e8e8e8 ;
}
.ganttFirstTableNamedSecond thead td {
  white-space: nowrap;
  height: 30px;
  padding: 4px 12px;
  background: #4B5558;
  color: #ffffff;
  min-width: 60px;
}
.ganttFirstTableNamedSecond thead td:nth-child(1) {
  min-width: 20px;
}
.ganttFirstTableUnnamed{
  display: block;
  overflow-x: auto;
}
.ganttFirstTableUnnamed tbody td{
  padding: 4px 8px;
  font-size: 13px;
  height: 40px;
  font-weight: 600;
  white-space: nowrap;
  border-bottom:1px solid #e8e8e8 ;
}
.ganttFirstTableUnnamed tbody tr:first-child td{
  border-bottom:none !important ;
}
.ganttFirstTableUnnamed thead td {
  white-space: nowrap;
  height: 30px;
  padding: 4px 12px;
  background: #4B5558;
  color: #ffffff;
  min-width: 60px;
}
.ganttFirstTableUnnamed thead td:nth-child(1), .ganttFirstTableUnnamed thead td:nth-child(2) {
  min-width: 20px !important;
}
.ganttFirstTableResults{
  width: 100%;
}
.ganttFirstTableResults tbody td{
  padding: 4px 8px;
  font-size: 13px;
  height: 40px;
  font-weight: 600;
  white-space: nowrap;
  border-bottom:1px solid #e8e8e8 ;
}
.ganttFirstTableResults tbody tr:first-child td{
  border-bottom:none !important ;
}
.ganttFirstTableResults thead td {
  white-space: nowrap;
  height: 30px;
  padding: 4px 12px;
  background: #4B5558;
  color: #ffffff;
}
.tooltipTable{
  background: #4B5558;
  color: #fff;
  width: auto;
  padding: 4px 8px;
  width: 500px;
}
.tooltipTable, .tooltipTable td {
  border: 1px solid #fff;
  border-collapse: collapse;
}
.tooltipTable td {
  padding: 4px;
}
.tooltipTableBig{
  background: #4B5558;
  color: #fff;
  width: auto;
  padding: 4px 8px;
  white-space: nowrap;
}
.tooltipTableBig, .tooltipTableBig td {
  border: 1px solid #fff;
  border-collapse: collapse;
}
.tooltipTableBig td {
  padding: 4px;
}
.MuiTypography-body1 {
  font-size: 1.01rem !important;
  font-weight: 600 !important;
  line-height: 1.5;
  letter-spacing: 0.00938em;
}
.individualRadio{
  padding: 0 !important;
}
.wrapperClass {
  border: 0.5px solid lightgrey;
}
iframe#webpack-dev-server-client-overlay {
  display:none !important
}
.ant-picker-dropdown {
  z-index: 999999 !important;
}
.rangeDatePicker {
  box-shadow: none !important;
  border-radius:2px !important ;
  height: 24px !important;
  border: 1px solid #cccccc;
}
.filterAntSelect .ant-select-selector {
  border: 1px solid #cccccc !important;
  border-radius: 2px !important;
}
.reportsSecondTable tbody, .reportsSecondTable  thead
{
    display: block;
}
.reportsSecondTable tbody 
{
   overflow-y: auto;
   max-height: 185px;
   overflow-x: hidden;
}
.reportsSecondTable tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}
.reportsSecondTable tbody td
{
   padding: 6px 16px 6px 6px !important;
}
.reportsSecondTable thead td
{
   padding: 6px 16px 6px 6px !important;
}
.contractSummaryTable tbody tr td:last-child {
  border-right: 1px solid #adadad;
}
.contractSummaryTable tbody tr:last-child td,.contractSummaryTable tbody tr:last-child th {
  border-bottom: 1px solid #adadad;
}
.contractSummaryTable tbody tr th:first-child {
  border-left: 1px solid #adadad;
}
.contractSummaryTable thead tr th:first-child {
  border-left: 1px solid #01539a;
}
.contractSummaryTable thead tr th:last-child {
  border-right: 1px solid #01539a;
}
.contractSummaryTable thead th {
  padding:  8px;
}
.firstTableFin thead th,.firstTableFin thead th,.secondTableFin thead th,.thirdTableFin thead th{
  background: #01539a;
  text-align: left;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
}
.secondTableFin thead th,.thirdTableFin thead th{
  height: 40px;
}
.firstTableFin tbody td,.secondTableFin tbody td,.thirdTableFin tbody td{
  height: 35px;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 4px;
}
.firstTableFin tbody tr td,.secondTableFin tbody tr td,.thirdTableFin tbody tr td{
  border-bottom: 1px solid #ccc;
}
.firstTableFin tbody tr:last-child td,.secondTableFin tbody tr:last-child td,.thirdTableFin tbody tr:last-child td{
  border-bottom: none !important;
}
.firstTableFin thead th{
  height: 80px;
}
.firstTableFinAttachemts.firstTableFin thead th{
  height: 32px !important;
}
.firstTableFin thead th:first-child,.secondTableFin thead th:first-child,.thirdTableFin thead th:first-child,.firstTableFin tbody tr td:first-child,.secondTableFin tbody tr td:first-child,.thirdTableFin tbody tr td:first-child{
  padding-left: 8px;
}
.centerAligned{
  text-align: center !important;
}
.headerLeftBorder{
  border-left: 1px solid #fff;
}
.totalRow td{
  font-weight: 600;
}
.centerAlignedHeaderLeftBorder{
  border-left: 1px solid #fff;
  text-align: center !important;
}
.actualsHeaderCell{
  text-align: center !important;
  background: #cecece !important;
  color: #000 !important;
}
.forecastHeaderCell{
  text-align: center !important;
  background: #939393 !important;
  color: #ffffff !important;
}
.centerAlignedDataLeftBorder {
  text-align: center !important;
  border-left: 1px solid #ccc;
}
.actualHeaderCost{
  background: #cecece !important;
  color: #000 !important;
}
.forecastHeaderCost{
  background: #939393 !important;
  color: #ffffff !important;
}
.adjustmentRow{
  
}
.totalDataRow td{
  font-weight: 600;
}
.cumulativeTotalRow td{
  font-weight: 600;
}
.plTable thead td{
  background: #01539a;
    text-align: left;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
    padding: 8px 4px;
}
.plTable{
  width: 100%;
}
.plTable thead td{
  background: #01539a;
    text-align: left;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
    padding: 12px 8px;
}
.plTable tbody td{
font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 4px;
    padding: 8px 4px 8px 8px;
    border-bottom:1px solid #e3e3e3 ;
}
.opportunityDetailsTableFirst{
  width: 100%;
}
.opportunityDetailsTableFirst thead td{
  background: #01539a;
    text-align: left;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
    height: 60px;
  padding-left: 16px;
}
.opportunityDetailsTableFirst tbody td{
font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 32px;
    border-bottom:1px solid #e3e3e3 ;
}
.pipelineOppsTable{
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
}
.pipelineOppsTable thead th{
  white-space: nowrap;
  background: #01539a;
    text-align: left;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
  padding: 8px 6px;
}
.pipelineOppsTable tbody td{
  padding:  6px;
  font-size: 13px;
}
.pipelineOppsTable tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}
.opportunityDetailsTableSecond{
  width: 100%;
}
.opportunityDetailsTableSecond thead td{
  background: #01539a;
    text-align: left;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
    height: 60px;
  padding: 4px 8px;
  min-width: 130px;
}
.opportunityDetailsTableSecond thead td:first-child{
    min-width: 145px !important;
    padding-left: 12px !important;
}
.opportunityDetailsTableSecond tbody td{
font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 32px;
    border-bottom:1px solid #e3e3e3 ;
}
.heatmapTable{
  width: 100%;
}
.heatmapTable thead td{
  background-color: #01539a;
  color: #fff;
  font-weight: 600;
  padding: 4px 6px;
}
.heatmapTable tbody td{
  padding: 4px 6px;
}
.ant-input-disabled.indirectNotes  {
  color: #373333 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb;;;AAGA;;GAEG,QAAQ;GACR,SAAS;GACT,WAAW;AACd;AACA;GACG,cAAc;GACd,iBAAiB;AACpB;AACA;GACG,mBAAmB,IAAI,yBAAyB;AACnD;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;GACG,iBAAiB;GACjB,QAAQ;GACR,UAAU;GACV,WAAW,IAAI,yBAAyB;GACxC,kBAAkB;GAClB,eAAe;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW,GAAG,4BAA4B;EAC1C,WAAW,EAAE,8BAA8B;AAC7C;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;AACA;CACC,YAAY;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;;AAEA,iBAAiB;;AAEjB;EACE,UAAU;EACV,kCAAkC;EAClC;uBACqB;AACvB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB,CAAC;EACC,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;IACX,mBAAmB;IACnB,uBAAuB;;AAE3B;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,wBAAwB;EACxB;;EAEA;EACA,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB;;EAEA;EACA,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB;;EAEA;EACA,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B;;EAEA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;CACC;EACC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,iCAAiC,EAAE,0CAA0C;AAC/E;AACA;EACE,WAAW;EACX,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;AACF;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;;IAEI,cAAc;AAClB;AACA;;GAEG,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;;GAEG,oCAAoC;AACvC;AACA;;GAEG,oCAAoC;AACvC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;;AAEA;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;AACA,eAAe;IACX,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;AACpC;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd,kBAAkB;AACpB;AACA;AACA,eAAe;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;AACA;EACE,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,mBAAmB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;IACjB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;AACA;AACA,eAAe;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".whiteSpaceKPITable .ck.ck-editor {\r\n  width: 185px;\r\n}\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #F6F8FC !important;\r\n  overflow-x: hidden;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n\r\nhtml,\r\nbody {\r\n   margin:0;\r\n   padding:0;\r\n   height:100%;\r\n}\r\n#root {\r\n   min-height:96%;\r\n   position:relative;\r\n}\r\n#body {\r\n   padding-bottom:16px;   /* Height of the footer */\r\n}\r\n.whiteSpaceKPITable {\r\n  width: 100%;\r\n  margin-top: 8px;\r\n}\r\n.whiteSpaceKPITable tbody td {\r\n  padding: 8px 4px;\r\n  border-bottom:1px solid #9FD0FA ;\r\n  /* color: #0b0c0c; */\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n}\r\n.whiteSpaceKPITable tbody tr:last-child td {\r\n  border-bottom:none ;\r\n}\r\n.whiteSpaceKPITable thead td {\r\n  padding: 8px 4px;\r\n  color: #104B72;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  background: #E0E8FA;\r\n  white-space: nowrap;\r\n  border-left:1px solid #104B72;\r\n}\r\n.whiteSpaceKPITable thead td:first-child {\r\n  border-left: none;\r\n}\r\n.whiteSpaceKPITable thead  {\r\n  border-radius: 5px;\r\n}\r\n.whiteSpaceKPITable thead td:first-child {\r\n  border-radius: 5px 0 0 5px;\r\n}\r\n.whiteSpaceKPITable thead td:last-child {\r\n  border-radius: 0 5px 5px 0;\r\n}\r\n#footer {\r\n   position:absolute;\r\n   bottom:0;\r\n   width:100%;\r\n   height:60px;   /* Height of the footer */\r\n   text-align: center;\r\n   padding: 20px 0;\r\n}\r\n#footerData{\r\n  padding: 8px 0;\r\n  font-size: 13px;\r\n  color: #4a4848;\r\n}\r\n\r\n::-webkit-scrollbar\r\n{\r\n  width: 10px;  /* for vertical scrollbars */\r\n  height: 8px; /* for horizontal scrollbars */\r\n}\r\n\r\n::-webkit-scrollbar-track\r\n{\r\n  background: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n::-webkit-scrollbar-thumb\r\n{\r\n  background: rgba(0, 0, 0, 0.4);\r\n  width: min-content;\r\n  border-radius: 10px;\r\n}\r\n.clearfix::after {\r\n  content: \"\";\r\n  clear: both;\r\n  display: table;\r\n}\r\n.datePicker{\r\n  height: 32px;\r\n  padding: 4px 4px 4px 8px;\r\n  border: 1px solid #ececec;\r\n  border-radius: 5px;\r\n  width: 100%;\r\n}\r\n.datePickerError{\r\n  height: 32px;\r\n  padding: 4px 4px 4px 8px;\r\n  border: 1px solid red;\r\n  border-radius: 5px;\r\n  width: 100%;\r\n}\r\n.datePickerDetailedView{\r\n height: 24px;\r\n  padding: 2px;\r\n  border: 1px solid #cccccc;\r\n  border-radius: 2px;\r\n  width: 100%; \r\n  font-size: 12px;\r\n}\r\n.datePickerDetailedView input{\r\n  font-size: 12px !important;\r\n}\r\n.datePickerFilter{\r\n  height: 24px;\r\n  padding: 4px 4px 4px 8px;\r\n  border: 1px solid #cccccc;\r\n  border-radius: 2px;\r\n  width: 100%;\r\n}\r\n.customCheckBox.MuiButtonBase-root {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n.customCheckBox .MuiSvgIcon-root{\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n.sortItem{\r\n  margin: 16px 0;\r\n  position: relative;\r\n}\r\n.graphTableToggle .MuiToggleButton-root {\r\n  height: 26px !important;\r\n  color: #000;\r\n}\r\n.graphTableToggle .MuiToggleButton-root.Mui-selected {\r\n  background-color: #0f8ec7 !important;\r\n  color: #fff !important;\r\n}\r\n.graphTableToggle .MuiToggleButtonGroup-grouped {\r\n  padding: 0px 4px 0px 4px !important;\r\n}\r\n.financialToggle .MuiToggleButton-root {\r\n  height: 32px !important;\r\n  color: #000;\r\n}\r\n.financialToggle .MuiToggleButton-root.Mui-selected {\r\n  background-color: #0f8ec7 !important;\r\n  color: #fff !important;\r\n}\r\n.financialToggle .MuiToggleButtonGroup-grouped {\r\n  padding: 4px 16px !important;\r\n}\r\n\r\n.gridRadioFilter .MuiTypography-body1 {\r\n  font-size: 13px !important;\r\n}\r\n.gridRadioFilter .MuiButtonBase-root {\r\n  padding: 0 10px !important;\r\n}\r\n\r\n.allocationPopupRadio .MuiTypography-body1 {\r\n  font-size: 12px !important;\r\n  font-weight: 600;\r\n}\r\n.allocationPopupRadio .MuiButtonBase-root {\r\n  padding: 0 6px !important;\r\n}\r\n.allocationPopupRadio .MuiSvgIcon-root{\r\n  width: 16px;\r\n  height: 16px;\r\n  font-size: 16px;\r\n  color: #0070D2;\r\n}\r\n\r\n.financialRadio .MuiTypography-body1 {\r\n  font-size: 14px !important;\r\n  font-weight: 600;\r\n}\r\n.financialRadio .MuiButtonBase-root {\r\n  padding: 0 6px !important;\r\n}\r\n.financialRadio .MuiSvgIcon-root{\r\n  width: 16px;\r\n  height: 16px;\r\n  font-size: 16px;\r\n  color: #0070D2;\r\n}\r\n\r\n/*Resource Table*/\r\n.resourceTable{\r\n  width: 100%;\r\n  padding: 12px 24px;\r\n}\r\n.resourceTable td{\r\n  text-align: center;\r\n}\r\n.resourceTable thead td{\r\n  text-align: center;\r\n  background: #4B5558;\r\n  color: #ffffff;\r\n  padding: 6px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  border-right: 1px solid #fff;\r\n}\r\n.resourceTable tbody td{\r\n  color: #343434;\r\n  padding: 6px;\r\n  font-size: 13px;\r\n  border-bottom: 1px solid #e3e3e3;\r\n  border-right:1px solid #e3e3e3 ;\r\n}\r\n.resourceTable tbody td:first-child{\r\n  border-left:1px solid #e3e3e3 ;\r\n}\r\n.resourceTable thead td:last-child{\r\n  width: 100px;\r\n}\r\n\r\n/*Resource Table*/\r\n\r\n.resourceDialog{\r\n  padding: 0;\r\n  /* max-width: 1200px !important; */\r\n  /* position:absolute !important;\r\n  left:20% !important */\r\n}\r\n.resourceDialog .MuiPaper-root{\r\n  max-width: 1200px !important;\r\n  overflow: hidden;\r\n}\r\n.worksheetTables{\r\n  border-spacing: 0px;\r\n  border-collapse: \"none\";\r\n  text-indent: \"initial\";\r\n}.filterMultiSelect .MuiFormControl-root{\r\n  height:32px;\r\n}\r\n.filterMultiSelect .MuiInputBase-root,.filterMultiSelect .MuiSelect-outlined.MuiSelect-outlined, .filterMultiSelect .Mui-focused{\r\n  height:32px;\r\n  font-size: 13px;\r\n  padding-top: 18px;\r\n  background: none !important;\r\n}\r\n.filterMultiSelect .MuiOutlinedInput-notchedOutline{\r\n  border: none !important;\r\n}\r\n.loadingPage {\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  z-index: 9999;\r\n  position: fixed;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n.loadingPageLabel {\r\n  color: #fff;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n}\r\n.react-datepicker-popper{\r\n  z-index: 999 !important;\r\n}\r\n\r\n.footorLogo{\r\n  margin-left: 8px;\r\n  margin-top: 2px;\r\n}\r\n.footerDataInnerClosed{\r\n  display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n.analyticsTable {\r\n  border-collapse: separate;\r\n  border-spacing:0 10px ;\r\n}\r\n\r\n.analyticsTable thead th{\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n\r\n.analyticsTable tbody td{\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n.analyticsTable thead {\r\n  background: #4B5558;\r\n  color: #fff;\r\n}\r\n.analyticsTable tbody tr{\r\n  text-align: center;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  height: 50px;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n}\r\n.analyticsTableMain tbody td {\r\n  max-width: 250px;\r\n}\r\n.tableRowsDdl .MuiSelect-select.MuiSelect-select {\r\n  padding-right: 12px;\r\n  font-size: 14px;\r\n  border: none;\r\n  padding-left: 4px;\r\n}\r\n.tableRowsDdl .MuiSvgIcon-root {\r\n  width: 18px;\r\n  height: 24px;\r\n  font-size: 16px;\r\n}\r\n.tableRowsDdl {\r\n  margin: 0 4px !important;\r\n  float: left;\r\n}\r\n.antSelectError .ant-select-selector, .errorEditor .ck.ck-editor {\r\n  border: 1px solid red !important;\r\n}\r\n.ant-picker-time-panel{\r\n  display: none !important;\r\n}\r\n.react-datepicker__day--outside-month {\r\n  color: #ccc !important;\r\n  pointer-events: none;\r\n}\r\ndiv[aria-hidden=\"true\"].tippy-popper {\r\n  display: none !important;\r\n}\r\n.generalSettingsTable{\r\n  width: 100%;  \r\n  word-break: break-word;\r\n}\r\n.generalSettingsTable thead td{\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n.generalSettingsTable thead{\r\n  background: #4B5558;\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n.generalSettingsTable tbody tr {\r\n  text-align: left;\r\n  position: relative;\r\n}\r\n.generalSettingsTable tbody td {\r\n  padding: 4px 8px;\r\n}\r\n.generalSettingsTable tbody tr:nth-child(even) {\r\n  background-color: #f5f5f5;\r\n}\r\n.settinsTableEdit {\r\n  visibility: hidden;\r\n  position: absolute;\r\n  left: 2px;\r\n  top: 6px;\r\n}\r\n.generalSettingsTable tbody tr:hover .settinsTableEdit {\r\n  visibility: visible;\r\n}\r\n.generalSettingsTable tbody tr td:first-child, .generalSettingsTable thead tr td:first-child {\r\n  padding-left: 16px;\r\n}\r\n\r\n\r\n.settingsTable{\r\n  width: 100%;\r\n  table-layout: fixed;\r\n  word-break: break-word;\r\n}\r\n.settingsTable thead td{\r\n  white-space: nowrap;\r\n  text-align: center;\r\n  padding: 4px 8px;\r\n  border-right: 1px solid #fff;\r\n  border-bottom: 1px solid #fff;\r\n}\r\n.settingsTable thead{\r\n  background: #4B5558;\r\n  color: #fff;\r\n}\r\n.settingsTable tbody tr {\r\n  text-align: left;\r\n}\r\n.settingsTable tbody td {\r\n  padding: 4px 8px;\r\n  color: #343434;\r\n  border-bottom:1px solid #ededed ;\r\n}\r\n.settingsTable tbody {\r\n  background: #fff;\r\n  font-size: 13px;\r\n}\r\n.picklistTable{\r\n  width: 100%;\r\n  table-layout: fixed;\r\n  word-break: break-word;\r\n}\r\n.settingsTable tbody tr:last-child td {\r\n  border-bottom:none !important;\r\n}\r\n\r\n.picklistTable thead td{\r\n  white-space: nowrap;\r\n  padding: 4px 8px;\r\n  text-align: left;\r\n  background: #fff;\r\n  color: #343434;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n}\r\n.picklistTable tbody td {\r\n  padding: 4px 8px;\r\n  color: #343434;\r\n  font-size: 13px;\r\n  border: none;\r\n}\r\n.allocationLandingTable{\r\n  width: 100%;\r\n  table-layout: fixed;\r\n  word-break: break-word;\r\n}\r\n.allocationLandingTable thead td{\r\n  padding: 6px 8px;\r\n}\r\n.allocationLandingTable tbody td{\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n}\r\n.allocationLandingTable tbody tr{\r\n  height: auto !important;\r\n}\r\n.requestsTable{\r\n  width: 120%;\r\n  /* table-layout: fixed; */\r\n  word-break: break-word;\r\n}\r\n.requestsTable thead td{\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n.requestsTable tbody td{\r\n  font-size: 13px;\r\n}\r\n.requestsTable tbody tr{\r\n  height: auto !important;\r\n  white-space: nowrap; \r\n}\r\n.requestsTable tbody tr td:nth-child(2) {\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  color: #09659c;\r\n}\r\n\r\n.requestsTable tbody tr.released-row td:nth-child(2) {\r\n  font-weight: 600;\r\n  cursor: default;\r\n  color: #999;\r\n}\r\n.requestsTable tbody tr td:last-child{\r\n  font-weight: 600;\r\n}\r\n\r\n.reportsTable{\r\n  width: 100%;\r\n  /* table-layout: fixed; */\r\n  word-break: break-word;\r\n}\r\n.reportsTable thead td{\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n.reportsTable tbody td{\r\n  font-size: 13px;\r\n}\r\n.reportsTable tbody tr{\r\n  height: auto !important;\r\n  white-space: nowrap; \r\n}\r\n.reportsTable {\r\n  border-collapse: separate;\r\n  border-spacing:0 10px ;\r\n}\r\n\r\n.reportsTable thead th{\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n\r\n.reportsTable tbody td{\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n.reportsTable thead {\r\n  background: #4B5558;\r\n  color: #fff;\r\n}\r\n.reportsTable tbody tr.reportsFirstTableRow{\r\n  text-align: center;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  min-height: 50px;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  white-space: nowrap; \r\n}\r\n.notificationTable {\r\n  border-collapse: separate;\r\n  border-spacing:0 10px ;\r\n}\r\n\r\n.notificationTable thead th{\r\n  white-space: nowrap;\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n\r\n.notificationTable tbody td{\r\n  text-align: left;\r\n  padding: 8px;\r\n}\r\n.notificationTable thead {\r\n  background: #4B5558;\r\n  color: #fff;\r\n}\r\n.notificationTable tbody tr{\r\n  text-align: center;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  min-height: 50px;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  white-space: nowrap; \r\n}\r\n.allocationProjectsTable{\r\n  width: 100%;\r\n}\r\n.allocationProjectsTable thead td{\r\n  white-space: nowrap;\r\n  text-align: center;\r\n  padding: 4px 8px;\r\n  border-right: 1px solid #fff;\r\n  border-bottom: 1px solid #fff;\r\n}\r\n.allocationProjectsTable thead{\r\n  background: #4B5558;\r\n  color: #fff;\r\n}\r\n\r\n.allocationProjectsTable tbody tr{\r\n  box-shadow: 0px 3px 6px #00000029;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  position: relative;\r\n}\r\n.allocationProjectsTable tbody td{\r\n  padding: 8px;\r\n}\r\n.spacerRow{\r\n  background: transparent !important;\r\n  box-shadow: none !important;\r\n}\r\n.allocationTableEdit {\r\n  position: absolute;\r\n  left: 4px;\r\n}\r\n.allocationProjectsTable tbody tr:hover .allocationTableEdit {\r\n  visibility: visible;\r\n}\r\n.allocationPopup .MuiDialog-paperWidthSm {\r\n  max-width: unset !important;\r\n}\r\n\r\n.ant-picker-calendar-date-value{\r\n  background-color: #031d40;  \r\n  width: 100%;  \r\n  height: 38%;  \r\n  text-align: center;  \r\n  color: #ffffff;  \r\n  font-size: 13px;  \r\n  font-weight: 600;  \r\n  border-radius:  12px 12px 0 0 !important;  \r\n  border: none !important ;  \r\n  }    \r\n  \r\n  .ant-picker-calendar-date-content{  \r\n  position: static;  \r\n  width: auto;  \r\n  height: 45px !important;  \r\n  overflow-y: auto;  \r\n  color: rgba(0, 0, 0, 0.88);  \r\n  line-height: 1.5714285714285714;  \r\n  text-align: start;  \r\n  }\r\n  \r\n  :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date {  \r\n  display: flex;\r\n  flex-direction: column;  \r\n  align-items: center;  \r\n  width: 40%;  \r\n  height: 46px;  \r\n  margin-bottom: 5px !important;  \r\n  padding: 0px !important;  \r\n  border: none;  \r\n  border-radius: 6px !important;  \r\n  align-items: center;  \r\n  }\r\n  \r\n  :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th{  \r\n  height: auto;  \r\n  padding-inline-end: 12px;  \r\n  padding-bottom: 4px;  \r\n  line-height: 18px;  \r\n  font-weight: 600;  \r\n  font-size: 18px;  \r\n  color: #4B5558;  \r\n  padding-left: 0px !important;  \r\n  padding-right: 86px !important;  \r\n  }\r\n  \r\n  .ant-picker-date-panel .ant-picker-cell:not(.ant-picker-cell-in-view) .ant-picker-cell-inner {  \r\n    display: none;  \r\n  }\r\n  :where(.css-dev-only-do-not-override-1i9hnpv).ant-input {\r\n    padding:  2px !important;\r\n  }\r\n  :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-dropdown .ant-picker-cell-disabled::before {\r\n    background: #ffffff !important;\r\n  }\r\n  .ant-picker-date-panel .ant-picker-cell:not(.ant-picker-cell-in-view) {  \r\n    pointer-events: none;  \r\n  }\r\n  :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 40%;\r\n    height: 46px;\r\n    margin: 6px;\r\n    padding: 0px !important;\r\n    border: none !important;\r\n    border-radius: 6px !important;\r\n    align-items: center;\r\n}\r\n:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date-value {\r\n  line-height: 18px;\r\n  transition: color 0.3s;\r\n}\r\n:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-panel .ant-picker-body th {\r\n  height: 5px !important;\r\n  padding-inline-end:0px !important;\r\n  padding-bottom: 0px !important;\r\n  line-height: 5px !important;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #4B5558;\r\n  padding-right: 96px !important;\r\n}\r\n:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar .ant-picker-panel .ant-picker-body {\r\n  padding: 2px 0 !important;\r\n}\r\n :where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date-content {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border: 1px solid #707070;\r\n  border-radius: 0 0 12px 12px;\r\n  background: #fff !important;\r\n  font-size: 13px !important;\r\n  overflow: hidden !important;\r\n} \r\n:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar .ant-picker-cell {\r\n  cursor: default !important;\r\n}\r\n:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-calendar-date-today .ant-picker-calendar-date-value{\r\n  color: #fff !important;\r\n}\r\n:where(.css-dev-only-do-not-override-1i9hnpv).ant-picker-calendar.ant-picker-calendar-full .ant-picker-cell-selected .ant-picker-calendar-date .ant-picker-calendar-date-value{\r\n  color: #fff !important;\r\n}\r\n.ant-picker-calendar-date-content{\r\n  font-size: 13px !important;\r\n}\r\n.makeStyles-inputBox-258:hover,\r\n.makeStyles-inputBox-258:focus {\r\n  border: 1px solid #ccc !important; /* Change border color on hover or click */\r\n}\r\n.ganttFirstTable{\r\n  width: 100%;\r\n  box-shadow: 0px 1px 6px #00000029;\r\n  font-size: 12px;\r\n}\r\n\r\n.ganttFirstTable thead td{\r\n  height: 30px;\r\n}\r\n.ganttFirstTable tbody td{\r\n  padding: 0 4px;\r\n}\r\n.ganttSecondTable{\r\n  display: block;\r\n  overflow-x: auto;\r\n  margin-left: 8px;\r\n  box-shadow: 0px 1px 6px #00000029;\r\n}\r\n.ganttSecondTable tbody td{\r\n  height: 30px;\r\n  padding: 4px;\r\n}\r\n.ganttSecondTableNamed{\r\n  display: block;\r\n  overflow-x: auto;\r\n  margin-left: 8px;\r\n  box-shadow: 0px 1px 6px #00000029;\r\n}\r\n.ganttSecondTableNamed tbody td{\r\n  padding: 4px;\r\n}\r\n.ganttFirstTableNamed{\r\n  display: block;\r\n  overflow-x: auto;\r\n}\r\n.ganttFirstTableNamed tbody td{\r\n  padding: 4px 8px;\r\n  font-size: 13px;\r\n  height: 100px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border-bottom:1px solid #e8e8e8 ;\r\n}\r\n.ganttFirstTableNamed thead td {\r\n  white-space: nowrap;\r\n  height: 30px;\r\n  padding: 4px 12px;\r\n  background: #4B5558;\r\n  color: #ffffff;\r\n  min-width: 60px;\r\n}\r\n.ganttFirstTableNamed thead td:nth-child(1) {\r\n  min-width: 20px;\r\n}\r\n\r\n.ganttFirstTableNamedSecond{\r\n  display: block;\r\n  overflow-x: hidden;\r\n}\r\n.ganttFirstTableNamedSecond tbody td{\r\n  padding: 4px 8px;\r\n  font-size: 13px;\r\n  height: 100px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border-bottom:1px solid #e8e8e8 ;\r\n}\r\n.ganttFirstTableNamedSecond thead td {\r\n  white-space: nowrap;\r\n  height: 30px;\r\n  padding: 4px 12px;\r\n  background: #4B5558;\r\n  color: #ffffff;\r\n  min-width: 60px;\r\n}\r\n.ganttFirstTableNamedSecond thead td:nth-child(1) {\r\n  min-width: 20px;\r\n}\r\n.ganttFirstTableUnnamed{\r\n  display: block;\r\n  overflow-x: auto;\r\n}\r\n.ganttFirstTableUnnamed tbody td{\r\n  padding: 4px 8px;\r\n  font-size: 13px;\r\n  height: 40px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border-bottom:1px solid #e8e8e8 ;\r\n}\r\n.ganttFirstTableUnnamed tbody tr:first-child td{\r\n  border-bottom:none !important ;\r\n}\r\n.ganttFirstTableUnnamed thead td {\r\n  white-space: nowrap;\r\n  height: 30px;\r\n  padding: 4px 12px;\r\n  background: #4B5558;\r\n  color: #ffffff;\r\n  min-width: 60px;\r\n}\r\n.ganttFirstTableUnnamed thead td:nth-child(1), .ganttFirstTableUnnamed thead td:nth-child(2) {\r\n  min-width: 20px !important;\r\n}\r\n.ganttFirstTableResults{\r\n  width: 100%;\r\n}\r\n.ganttFirstTableResults tbody td{\r\n  padding: 4px 8px;\r\n  font-size: 13px;\r\n  height: 40px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border-bottom:1px solid #e8e8e8 ;\r\n}\r\n.ganttFirstTableResults tbody tr:first-child td{\r\n  border-bottom:none !important ;\r\n}\r\n.ganttFirstTableResults thead td {\r\n  white-space: nowrap;\r\n  height: 30px;\r\n  padding: 4px 12px;\r\n  background: #4B5558;\r\n  color: #ffffff;\r\n}\r\n.tooltipTable{\r\n  background: #4B5558;\r\n  color: #fff;\r\n  width: auto;\r\n  padding: 4px 8px;\r\n  width: 500px;\r\n}\r\n.tooltipTable, .tooltipTable td {\r\n  border: 1px solid #fff;\r\n  border-collapse: collapse;\r\n}\r\n.tooltipTable td {\r\n  padding: 4px;\r\n}\r\n.tooltipTableBig{\r\n  background: #4B5558;\r\n  color: #fff;\r\n  width: auto;\r\n  padding: 4px 8px;\r\n  white-space: nowrap;\r\n}\r\n.tooltipTableBig, .tooltipTableBig td {\r\n  border: 1px solid #fff;\r\n  border-collapse: collapse;\r\n}\r\n.tooltipTableBig td {\r\n  padding: 4px;\r\n}\r\n.MuiTypography-body1 {\r\n  font-size: 1.01rem !important;\r\n  font-weight: 600 !important;\r\n  line-height: 1.5;\r\n  letter-spacing: 0.00938em;\r\n}\r\n.individualRadio{\r\n  padding: 0 !important;\r\n}\r\n.wrapperClass {\r\n  border: 0.5px solid lightgrey;\r\n}\r\niframe#webpack-dev-server-client-overlay {\r\n  display:none !important\r\n}\r\n.ant-picker-dropdown {\r\n  z-index: 999999 !important;\r\n}\r\n.rangeDatePicker {\r\n  box-shadow: none !important;\r\n  border-radius:2px !important ;\r\n  height: 24px !important;\r\n  border: 1px solid #cccccc;\r\n}\r\n.filterAntSelect .ant-select-selector {\r\n  border: 1px solid #cccccc !important;\r\n  border-radius: 2px !important;\r\n}\r\n.reportsSecondTable tbody, .reportsSecondTable  thead\r\n{\r\n    display: block;\r\n}\r\n.reportsSecondTable tbody \r\n{\r\n   overflow-y: auto;\r\n   max-height: 185px;\r\n   overflow-x: hidden;\r\n}\r\n.reportsSecondTable tbody tr:nth-child(even) {\r\n  background-color: #f5f5f5;\r\n}\r\n.reportsSecondTable tbody td\r\n{\r\n   padding: 6px 16px 6px 6px !important;\r\n}\r\n.reportsSecondTable thead td\r\n{\r\n   padding: 6px 16px 6px 6px !important;\r\n}\r\n.contractSummaryTable tbody tr td:last-child {\r\n  border-right: 1px solid #adadad;\r\n}\r\n.contractSummaryTable tbody tr:last-child td,.contractSummaryTable tbody tr:last-child th {\r\n  border-bottom: 1px solid #adadad;\r\n}\r\n.contractSummaryTable tbody tr th:first-child {\r\n  border-left: 1px solid #adadad;\r\n}\r\n.contractSummaryTable thead tr th:first-child {\r\n  border-left: 1px solid #01539a;\r\n}\r\n.contractSummaryTable thead tr th:last-child {\r\n  border-right: 1px solid #01539a;\r\n}\r\n.contractSummaryTable thead th {\r\n  padding:  8px;\r\n}\r\n.firstTableFin thead th,.firstTableFin thead th,.secondTableFin thead th,.thirdTableFin thead th{\r\n  background: #01539a;\r\n  text-align: left;\r\n  color: #ffffff;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n}\r\n.secondTableFin thead th,.thirdTableFin thead th{\r\n  height: 40px;\r\n}\r\n.firstTableFin tbody td,.secondTableFin tbody td,.thirdTableFin tbody td{\r\n  height: 35px;\r\n  font-size: 13px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  padding-right: 4px;\r\n}\r\n.firstTableFin tbody tr td,.secondTableFin tbody tr td,.thirdTableFin tbody tr td{\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n.firstTableFin tbody tr:last-child td,.secondTableFin tbody tr:last-child td,.thirdTableFin tbody tr:last-child td{\r\n  border-bottom: none !important;\r\n}\r\n.firstTableFin thead th{\r\n  height: 80px;\r\n}\r\n.firstTableFinAttachemts.firstTableFin thead th{\r\n  height: 32px !important;\r\n}\r\n.firstTableFin thead th:first-child,.secondTableFin thead th:first-child,.thirdTableFin thead th:first-child,.firstTableFin tbody tr td:first-child,.secondTableFin tbody tr td:first-child,.thirdTableFin tbody tr td:first-child{\r\n  padding-left: 8px;\r\n}\r\n.centerAligned{\r\n  text-align: center !important;\r\n}\r\n.headerLeftBorder{\r\n  border-left: 1px solid #fff;\r\n}\r\n.totalRow td{\r\n  font-weight: 600;\r\n}\r\n.centerAlignedHeaderLeftBorder{\r\n  border-left: 1px solid #fff;\r\n  text-align: center !important;\r\n}\r\n.actualsHeaderCell{\r\n  text-align: center !important;\r\n  background: #cecece !important;\r\n  color: #000 !important;\r\n}\r\n.forecastHeaderCell{\r\n  text-align: center !important;\r\n  background: #939393 !important;\r\n  color: #ffffff !important;\r\n}\r\n.centerAlignedDataLeftBorder {\r\n  text-align: center !important;\r\n  border-left: 1px solid #ccc;\r\n}\r\n.actualHeaderCost{\r\n  background: #cecece !important;\r\n  color: #000 !important;\r\n}\r\n.forecastHeaderCost{\r\n  background: #939393 !important;\r\n  color: #ffffff !important;\r\n}\r\n.adjustmentRow{\r\n  \r\n}\r\n.totalDataRow td{\r\n  font-weight: 600;\r\n}\r\n.cumulativeTotalRow td{\r\n  font-weight: 600;\r\n}\r\n.plTable thead td{\r\n  background: #01539a;\r\n    text-align: left;\r\n    color: #ffffff;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    padding: 8px 4px;\r\n}\r\n.plTable{\r\n  width: 100%;\r\n}\r\n.plTable thead td{\r\n  background: #01539a;\r\n    text-align: left;\r\n    color: #ffffff;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    padding: 12px 8px;\r\n}\r\n.plTable tbody td{\r\nfont-size: 13px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    padding-right: 4px;\r\n    padding: 8px 4px 8px 8px;\r\n    border-bottom:1px solid #e3e3e3 ;\r\n}\r\n.opportunityDetailsTableFirst{\r\n  width: 100%;\r\n}\r\n.opportunityDetailsTableFirst thead td{\r\n  background: #01539a;\r\n    text-align: left;\r\n    color: #ffffff;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    height: 60px;\r\n  padding-left: 16px;\r\n}\r\n.opportunityDetailsTableFirst tbody td{\r\nfont-size: 13px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    height: 32px;\r\n    border-bottom:1px solid #e3e3e3 ;\r\n}\r\n.pipelineOppsTable{\r\n  width: 100%;\r\n  box-shadow: 0px 3px 6px #00000029;\r\n}\r\n.pipelineOppsTable thead th{\r\n  white-space: nowrap;\r\n  background: #01539a;\r\n    text-align: left;\r\n    color: #ffffff;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n  padding: 8px 6px;\r\n}\r\n.pipelineOppsTable tbody td{\r\n  padding:  6px;\r\n  font-size: 13px;\r\n}\r\n.pipelineOppsTable tbody tr:nth-child(even) {\r\n  background-color: #f5f5f5;\r\n}\r\n.opportunityDetailsTableSecond{\r\n  width: 100%;\r\n}\r\n.opportunityDetailsTableSecond thead td{\r\n  background: #01539a;\r\n    text-align: left;\r\n    color: #ffffff;\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    height: 60px;\r\n  padding: 4px 8px;\r\n  min-width: 130px;\r\n}\r\n.opportunityDetailsTableSecond thead td:first-child{\r\n    min-width: 145px !important;\r\n    padding-left: 12px !important;\r\n}\r\n.opportunityDetailsTableSecond tbody td{\r\nfont-size: 13px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    height: 32px;\r\n    border-bottom:1px solid #e3e3e3 ;\r\n}\r\n.heatmapTable{\r\n  width: 100%;\r\n}\r\n.heatmapTable thead td{\r\n  background-color: #01539a;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  padding: 4px 6px;\r\n}\r\n.heatmapTable tbody td{\r\n  padding: 4px 6px;\r\n}\r\n.ant-input-disabled.indirectNotes  {\r\n  color: #373333 !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
